import { customAxios, customPatchAxios } from "./customAxios";

/**
 * 사용자 전체 목록
 * @returns 
 */
export const getUsersAll = async()=>{
  const res = await customAxios.get('/api/users');
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 사용자 목록(파라미터)
 * @param {*} query 
 * @returns 
 */
export const getUsersByQuery = async(query)=>{
  const res = await customAxios.get('/api/users', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 사용자 상세
 * @param {*} id 
 * @returns 
 */
export const getUsersById = async(id)=>{
  const res = await customAxios.get('/api/users/'+id);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 사용자 등록
 * @param {*} body 
 */
export const postUsers = async(body)=>{
  //console.log(body);
  const res = await customAxios.post('/api/users',body);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 사용자 수정
 * @param {*} body 
 */
export const patchUsers = async(body)=>{
  //console.log(body);
  const res = await customPatchAxios.patch('/api/users/'+body.id, body);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 사용자 수정2
 * @param {*} body 
 */
// export const patchUsersIncludingEquipmentZoneManager = async(body)=>{
//   //console.log(body);
//   await customPatchAxios.patch('/api/users/'+body.id+':includingEquipmentZoneManager', body);
// }

/**
 * 사용자 삭제
 * @param {*} param 
 */
export const deleteUsers = async(param)=>{
  //console.log(param);
  const res = await customAxios.delete('/api/users/'+param);
  if (res.data) {
    return res.data;
  }
  return null;
}
